import { PropsWithChildren } from "react";
import { motion, type Variants } from "framer-motion";

const container: Variants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.06 },
  },
};

const item: Variants = {
  hidden: { opacity: 0, y: 8 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.2, ease: "easeOut" },
  },
};

export function StaggerFade({ children }: PropsWithChildren) {
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={container}
      style={{ display: "contents" }} // let Bootstrap grid flow
     
    > 
      {Array.isArray(children) ? (
        children.map((child, idx) => (
          <motion.div key={idx} variants={item} style={{ display: "contents"  }} >
            {child}
          </motion.div>
        ))
      ) : (
        <motion.div variants={item} style={{ display: "contents" }}>
          {children}
        </motion.div>
      )}
    </motion.div>
  );
}
